import { jsx as _jsx } from "react/jsx-runtime";
import Modal from '../../Modal/Modal';
import React, { useCallback, useState } from 'react';
import ChatList from './components/ChatList/ChatList';
import ChatSingle from './components/ChatSingle/ChatSingle';
import styles from './ChatModal.module.scss';
export var CHAT_MODAL_VIEWS;
(function (CHAT_MODAL_VIEWS) {
    CHAT_MODAL_VIEWS["LIST_VIEW"] = "LIST_VIEW";
    CHAT_MODAL_VIEWS["CHAT_VIEW"] = "CHAT_VIEW";
})(CHAT_MODAL_VIEWS || (CHAT_MODAL_VIEWS = {}));
const ChatModal = ({ closeModal, chatViews, memberId, singleChat, guildChat }) => {
    const [chatView, setChatView] = useState(chatViews);
    const onSwitchToChatView = useCallback(() => {
        setChatView(CHAT_MODAL_VIEWS.CHAT_VIEW);
    }, [setChatView]);
    const onSwitchToListView = useCallback(() => {
        setChatView(CHAT_MODAL_VIEWS.LIST_VIEW);
    }, [setChatView]);
    const displayComponents = {
        [CHAT_MODAL_VIEWS.CHAT_VIEW]: (_jsx(ChatSingle, { isGuildChat: guildChat, singleChat: singleChat, memberId: memberId, onSwitchToListView: onSwitchToListView })),
        [CHAT_MODAL_VIEWS.LIST_VIEW]: _jsx(ChatList, { onSwitchToChatView: onSwitchToChatView })
    };
    return (_jsx(Modal, Object.assign({ closeModal: closeModal, className: styles.element }, { children: displayComponents[chatView] })));
};
export default ChatModal;
